import { breakpoints } from '../../../styles/breakpoints';
import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;  
  margin-top: 3.125rem;
`;

export const Loader = styled.img`
  max-width: 6.25rem;

  @media ${breakpoints.md} {
    max-width: 5rem;
  }
`;
